import { render, staticRenderFns } from "./ProjekteIcon.vue?vue&type=template&id=18aaae4d"
import script from "./ProjekteIcon.vue?vue&type=script&lang=js"
export * from "./ProjekteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports